import _ from 'lodash'

/**
 * @type {VuexState}
 */
const initialState = {

    scheme: null,
    metricsLoaded: false,

    /**
     * @returns {?string}
     */
    requestToken: null,

    /**
     * A timestamp, in seconds, when a project load was last loaded.
     * @returns {?number}
     */
    projectLastLoaded: null,

    /**
     * @returns {?PropertyAsJson}
     */
    property: null,

    propertyLinkedSchemes: null,
    propertyCalculationInProgress: false,

    /**
     * @returns {?Context}
     */
    authContext: null,
    appErrors: [],
    userLinkedProperties: [],
    windowWidth: window && window.innerWidth,
    serviceDown: false,

    /**
     * @returns {?string}
     */
    partnerReferralId: null,

    /**
     * @returns {string[]}
     */
    visitedRoutes: [],

    /**
     * @returns {Object}
     */
    searchedAddresses: {},
}

/**
 * @type {VuexState}
 */
const state = _.cloneDeep(initialState)

export { initialState }

export default state
